import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { environment } from '../environments/environment';
import * as firebase from 'firebase/app';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
    constructor(public toastr: ToastsManager, vRef: ViewContainerRef) {
        this.toastr.setRootViewContainerRef(vRef);
        window.dispatchEvent(new Event('resize'));
    }

    ngOnInit() {
        firebase.initializeApp(environment.firebaseConfig);
    }
}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts